module.exports = __webpack_public_path__ + "img/schizaphis-graminum.9d33967c.jpg";